
export const MenuBarItem = {
  OpenMenu:{name:'OPEN_MENU',need_login:false},
  CloseMenu:{name:'CLOSE_MENU',need_login:false},
  Alarm:{name:'ALARM',need_login:false},
  Barcode:{name:'BARCODE',need_login:true},
  Cart:{name:'CART',need_login:true}
}
export const MenuAuth = {



  Order:{name:'ORDER',need_login:true},                      //Side,main menu - 멤버십오더
  GiftShop:{name:'GIFT_SHOP',need_login:true},               //Side,main menu - 기프트샵
  FindStore:{name:'FIND_STORE',need_login:true},             //Side,main menu - 매장찾기
  ShowMenu:{name:'SHOW_MENU',need_login:true},               //Side menu - 메뉴보기
  OrderHistory:{name:'ORDER_HISTORY',need_login:true},       //Side menu - 주문내역
  EventNews:{name:'EVENT_NEWS',need_login:false},             //Side,main menu - 이벤트&뉴스

  Alarm:{name:'ALARM',need_login:false},                      //Side menu - 알림내역
  Benefit:{name:'BENEFIT',need_login:false},                  //Side menu - 회원혜택
  ServiceCenter:{name:'SERVICE_CENTER',need_login:false},     //Side menu - 고객센터
  Information:{name:'INFORMATION',need_login:false},          //Side menu - 이용안내

  Stamp:{name:'STAMP',need_login:true},                      //menu - 스탬프
  Coupon:{name:'COUPON',need_login:true},                    //menu - 쿠폰
  PrepaidCard:{name:'PREPAID_CARD',need_login:true},          //menu - 선불카드  

  MemberShip:{name:'MEMBERSHIP',need_login:true},              //top menu - membership
  Settings:{name:'SETTINGS',need_login:true}
}

// export const Menu = {
//   Order:'ORDER',                      //Side,main menu - 멤버십오더
//   GiftShop:'GIFT_SHOP',               //Side,main menu - 기프트샵
//   FindStore:'FIND_STORE',             //Side,main menu - 매장찾기
//   ShowMenu:'SHOW_MENU',               //Side menu - 메뉴보기
//   OrderHistory:'ORDER_HISTORY',       //Side menu - 주문내역
//   EventNews:'EVENT_NEWS',             //Side,main menu - 이벤트&뉴스

//   Alarm:'ALARM',                      //Side menu - 알림내역
//   Benefit:'BENEFIT',                  //Side menu - 회원혜택
//   ServiceCenter:'SERVICE_CENTER',     //Side menu - 고객센터
//   Information:'INFORMATION',          //Side menu - 이용안내

//   Stamp:'STAMP',                      //menu - 스탬프
//   Coupon:'COUPON',                    //menu - 쿠폰
//   PrepaidCard:'PREPAID_CARD'          //menu - 선불카드  
// }


export const DefaultSettings = {
  CategoryId : 0,
  OrderType : 'ORD',
  ColdNHot : 1
}

export const OrderType = {
  // StoreOrder:0,
  // DeliveryOrder:1
  MemberShip:'ORD',
  Delivery:'DLV',
  Table:'TBL',
  EGift:'EGT'
}
export const PayOrderType = {
  // StoreOrder:0,
  // DeliveryOrder:1
  Menu:'MENU',
  Gift:'GIFT',
  Card:'CARD',  
}

export const PayMenuType = {
  // StoreOrder:0,
  // DeliveryOrder:1
  Menu:'MENU',
  EGift:'EGIFT',
  Card:'CARD',  
}

export const OrderFrom = {
  Direct:0,
  Cart:1  
}

export const OrderItemType = {
  Order:'ORDER',
  Delivery:'DELIVERY',
  Table:'TABLE',
  All:'ALL'
}

export const StoreListType = {
  Recently:0,
  DeliveryOrder:1
}

export const SearchType = {  
  Order:'ORDER',
  Delivery:'DELIVERY',
  Table:'TABLE',
  All:'ALL'
}

export const PayMethods = {
  Gift:1,
  Card:2,
  Phone:3
}
export const PayActions = {
  Payment:'PAYMENT',
  Cancel:'CANCEL_PAYMENT',
}

export const PayMethodType = {
  PrePaid:'PREPAID',
  Credit:'CREDIT',
  Mobile:'MOBILE',
  Exchange:'EXCHANGE' //- 결제금액이 0일때
}
export const EZPayMethodType = {
  PrePaid:'50',
  Credit:'11',
  Mobile:'31'
}

export const GiftShopTabType = {      
    Default:'default',
    eGift:'egift',
    Card:'card',
    GiftBox:'giftbox'
}
export const FindShowTabType = {
    Search: 'ShopSearch',
    Near: 'ShopNear',
    My: 'ShopMy'
}
export const EventNewsTabType = {
  Event:'event',
  News:'news',  
}
export const StampTabType = {
    Card: 'StampCard',
    List: 'StampList',
}
export const LocalStorageConfig = {
  GiftShopTab : 'gift_shop_main_tab',
  FindShopTab : 'find_shop_main_tab',
  EventNewsTab : 'event_news_main_tab',
  StoreHistoryTab : 'store_order_history_tab',
  Contact : 'contact',
  Barcode : 'barcode',
  AccessToken : 'accessToken',
  AutoLoginInfo : 'auto_login_info'
  // LoginInfo:{
  //   AutoLogin:false,
  //   LoginId:'',
  //   LoginPwd:'',
  // }
}

export const GiftStatus = {
  Pay :{status:'PAY',name:'전송전'},
  Send :{status:'SND',name:'전송완료'},
  Completed :{status:'COM',name:'등록완료'},
  Failed :{status:'FAL',name:'전송실패'},
  Canceled :{status:'CNL',name:'취소'},
  Rejected :{status:'REJ',name:'거절'}

}

export const CouponSearchType = {
  Usable: "USABLE",
  Present: "PRESENT",
  Used: "USED"
}

export const CouponStatus = {
  Activated: {status:"ACT", text:"사용_가능"},
  Sent: {status:"SND", text:"선물_중"},
  Expired: {status:"EPR", text:"기간_만료"},
  Used: {status:"USE", text:"사용_완료"}
}

export const GiftSendType = {
  Kakao:'KAKAO',
  Sms:'SMS'
}
export const GiftType = {
  MemberShipMenu:'MEMBERSHIP_MENU',
  MemberShipCart:'MEMBERSHIP_CART',
  GiftCart:'GIFT_CART',
  EGift:'EGIFT',
  Card:'CARD',  
}

export const PaymentResultCode = {
  Success : 0,
  Canceled : 1,
  Failed : 2
}

export const StoreSearchType = {
  Order:'ORD',
  Delivery:'DLV',
  Table:'TABLE',
  All:'ALL'
}


// WEBPACK FOOTER //
// ./src/components/AppConstants.js